import { $createParagraphNode, $createTextNode, $getRoot, LexicalEditor, TextNode } from 'lexical';
import { $createMentionNode } from '../nodes/MentionNode';
import { $createHashtagNode } from '../nodes/HashtagNode';
import { $createSlashNode } from '../nodes/SlashNode';

export const initPost = (editor: LexicalEditor, data: InitialPostData) => {
  const mentions = data?.entities?.mentions?.map(i => ({ ...i, type: 'mention' })) || [];
  const tags = data?.entities?.tags?.map(i => ({ ...i, type: 'tag' })) || [];
  const channels = data?.entities?.channels?.map(i => ({ ...i, type: 'channels' })) || [];
  const insertList = [...mentions, ...tags, ...channels];

  editor.update(() => {
    const root = $getRoot();
    root.clear();
    const paragraph = $createParagraphNode();
    const lastNode = new TextNode('');
    const contentStr = data?.content || '';
    let insertElement;
    // 使用[...contentStr]解决emoji的字符串长度问题
    [...contentStr]?.forEach((str, index) => {
      insertElement = insertList.find(i => index >= i?.indices?.[0] && index < i?.indices?.[1]);
      if (insertElement) {
        if (index !== insertElement?.indices?.[0]) {
          return;
        }
        if (insertElement?.type === 'mention') {
          // @ts-ignore
          const mentionNode = $createMentionNode(`${insertElement?.raw_string}`, {
            id: insertElement?.id,
          });
          paragraph.append(mentionNode);
        } else if (insertElement?.type === 'tag') {
          const tagNode = $createHashtagNode(insertElement?.raw_string, {
            id: insertElement?.id,
            name: insertElement?.name,
          });
          paragraph.append(tagNode);
        } else {
          const node = $createSlashNode(insertElement?.raw_string, {
            id: insertElement?.id,
          });
          paragraph.append(node);
        }
        return;
      }
      paragraph.append($createTextNode(str));
    });
    paragraph.append(lastNode);
    lastNode.select(1, 1);
    root.append(paragraph);
  });
  setTimeout(() => {
    editor.focus();
  }, 500);
};
